import { render, staticRenderFns } from "./ExcelExport.vue?vue&type=template&id=2b0a0ba0&scoped=true"
import script from "./ExcelExport.vue?vue&type=script&lang=js"
export * from "./ExcelExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0a0ba0",
  null
  
)

export default component.exports